import { useQuery } from '@apollo/client';
import { GET_IS_FACEBOOK_FIRST_COMMENT_HASHTAGS_ENABLED } from './useIsFacebookFirstCommentHashtagsEnabled.queries';
import { GetIsFacebookFirstCommentHashtagsEnabled } from './__graphqlTypes/GetIsFacebookFirstCommentHashtagsEnabled';

export function useIsFacebookFirstCommentHashtagsEnabled(): boolean {
    const { data } = useQuery<GetIsFacebookFirstCommentHashtagsEnabled>(GET_IS_FACEBOOK_FIRST_COMMENT_HASHTAGS_ENABLED);
    return !!data?.config.features.publishing.facebookFirstCommentHashtags;
}
